var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLightbulbIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 147.66 162.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".n{fill:url(#e);}.o{fill:url(#g);}.p{fill:url(#f);}.q{fill:url(#i);}.r{fill:url(#h);}.s{fill:url(#k);}.t{fill:url(#j);}.u{fill:url(#m);}.v{fill:url(#l);}.w{fill:#00b4e6;}.x{fill:#fefbd6;}.y{fill:#58595b;}.a`{fill:#231f20;}.a`,.aa{mix-blend-mode:soft-light;}.aa{fill:#00b4ff;}.ab{isolation:isolate;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 73.98,
    y1: 31.21,
    x2: 73.98,
    y2: 0,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffae00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff224"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 18.9,
    y1: 28.13,
    x2: 37.83,
    y2: 47.07,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff224"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffae00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 108.53,
    y1: 117.77,
    x2: 120.74,
    y2: 129.97,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 26.84,
    y1: 130.27,
    x2: 39.04,
    y2: 118.06,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 126.56,
    y1: 30.54,
    x2: 112.01,
    y2: 45.1,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 0,
    y1: 83.17,
    x2: 25.52,
    y2: 83.17,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 122.13,
    y1: 83.17,
    x2: 147.66,
    y2: 83.17,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 35.04,
    y1: 84.95,
    x2: 112.8,
    y2: 84.95,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffde0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffce00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 73.68,
    y1: 129.27,
    x2: 73.68,
    y2: 84.29,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#ba6c1a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#c77515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#e98c0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9b05"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "ab"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M73.71,162.79h0c-4.51,0-7.73-2.56-9.74-5.3l-.15-.15h19.73l-.15,.15c-2,2.92-6,5.3-9.68,5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M73.98,0c-1.96,0-3.55,1.59-3.55,3.55V27.66c0,1.96,1.59,3.55,3.55,3.55s3.55-1.59,3.55-3.55V3.55c0-1.96-1.59-3.55-3.55-3.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M33.53,47.07c.58,.58,1.34,.89,2.15,.89s1.58-.32,2.15-.89c1.19-1.19,1.19-3.12,0-4.31l-14.63-14.63c-.58-.58-1.34-.89-2.15-.89s-1.58,.32-2.15,.89c-.58,.58-.89,1.34-.89,2.15s.32,1.58,.89,2.15l14.63,14.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M110.17,115.82c-.48-.48-1.12-.74-1.79-.74s-1.32,.26-1.79,.74c-.99,.99-.99,2.6,0,3.59l12.19,12.19c.48,.48,1.12,.74,1.79,.74s1.31-.26,1.79-.74c.48-.48,.74-1.12,.74-1.79s-.26-1.32-.74-1.79l-12.19-12.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M39.38,115.19c-.68,0-1.32,.26-1.79,.74l-12.19,12.19c-.48,.48-.74,1.12-.74,1.79s.26,1.32,.74,1.79c.48,.48,1.12,.74,1.79,.74s1.32-.26,1.79-.74l12.19-12.19c.99-.99,.99-2.6,0-3.59-.48-.48-1.12-.74-1.79-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M113.53,47.24c1.42-.72,2.45-1.8,3.57-2.92,1.66-1.66,3.31-3.31,4.97-4.97,1.65-1.65,3.3-3.3,4.95-4.95,.53-.53,1.06-1.06,1.59-1.59,.58-.58,.89-1.34,.89-2.15s-.32-1.58-.89-2.15c-.58-.58-1.34-.89-2.15-.89s-1.58,.32-2.15,.89l-14.63,14.63c-1.48,1.48-1.03,4.14,1.15,4.6,.78,.17,1.6,.01,2.33-.31,.13-.06,.26-.12,.38-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M25.52,83.17c0-1.6-1.3-2.9-2.9-2.9H2.9c-1.6,0-2.9,1.3-2.9,2.9s1.3,2.9,2.9,2.9H22.62c1.6,0,2.9-1.3,2.9-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M144.75,80.27h-19.72c-1.6,0-2.9,1.3-2.9,2.9s1.3,2.9,2.9,2.9h19.72c1.6,0,2.9-1.3,2.9-2.9s-1.3-2.9-2.9-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M112.8,80c0,10.21-3.93,19.5-10.37,26.44-4.67,5.03-7.69,11.37-8.63,18.17l-.14,1.02c-.25,1.81-1.8,3.16-3.63,3.16H57.82c-1.83,0-3.38-1.35-3.63-3.16l-.16-1.19c-.39-2.83-1.16-5.58-2.26-8.19-1.52-3.61-3.68-6.94-6.37-9.85-6.18-6.68-10.05-15.52-10.33-25.27-.64-22.36,17.85-40.74,40.2-39.99,3.43,.12,6.75,.68,9.9,1.63,15.99,4.82,27.64,19.67,27.64,37.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M96.24,91.22c-.19-4.5-3.17-6.92-7.66-6.92-.12,0-.24,0-.36,0-4.27,.18-7.63,1.75-8.33,7.39l-.39,4.67h-12.06l-.39-4.68c-.45-4.81-3.04-7.2-7.31-7.38-4.66-.2-8.43,2.29-8.62,6.9-.09,2.23,.69,4.37,2.2,6.01,1.51,1.65,2.79,2.06,5.02,2.15h6.32l2.42,29.89,3.05-.29-2.4-29.59h11.48l-2.77,29.59,3.55,.29,2.42-29.89h5.81c2.23-.1,4.29-.5,5.81-2.14,1.51-1.65,2.3-3.78,2.2-6.01Zm-8.13,5.15h-5.4l.36-4.36c.23-2.52,1.75-5.12,4.61-5.24,2.67-.11,4.89,1.95,5,4.6,.11,2.63-1.94,4.87-4.57,5Zm-23.75,0h-6.31c-2.63-.13-4.16-2.37-4.16-5,0-3.24,2.22-4.6,4.81-4.6,.07,0,.13,0,.2,0,2.86,.12,4.87,2.71,5.11,5.23l.36,4.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M90.76,135.82c0-.22,.09-.45,.33-.72,.75-.85,1.33-1.58,1.33-2.78,0-1.97-1.61-3.59-3.59-3.59h-30.23c-1.97,0-3.59,1.61-3.59,3.59,0,1.11,.52,2.12,1.37,2.82,.46,.37,1.04,.5,.65,1.1-.25,.39-.87,.59-1.18,.96-.54,.64-.84,1.49-.84,2.3,0,1.21,.63,2.35,1.64,3.01,.52,.34,.89,.34,.39,.94-.32,.38-.85,.52-1.18,.91-.55,.64-.85,1.47-.85,2.32,0,1.33,.7,2.2,1.65,3.01,.99,.85,.86,2.23,1.38,3.38,.46,1.01,1.12,1.92,1.95,2.66l.09,.08c1.16,1.04,2.66,1.62,4.22,1.62h18.84c1.56,0,3.06-.58,4.22-1.62l.09-.08c.85-.77,1.54-1.72,2-2.77,.47-1.08,.54-2.51,1.39-3.32,.89-.85,1.58-1.62,1.58-2.95,0-.79-.27-1.57-.75-2.19-.55-.7-1.34-1.26-.67-2.13,.72-.95,1.42-1.53,1.42-2.85,0-.79-.27-1.57-.75-2.19-.42-.55-.9-.98-.9-1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M55.93,144.28s.06-.05,.1-.08c-.03,.03-.07,.05-.1,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M59.88,52.36c.78,1.07-.36,3.22-2.55,4.8-2.18,1.58-4.58,1.99-5.36,.92-.78-1.07,.36-3.22,2.55-4.8,2.18-1.58,4.58-1.99,5.36-.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M50.37,59.71c.5,.23,.54,1.24,.07,2.27-.46,1.02-1.25,1.67-1.75,1.44-.5-.23-.54-1.24-.07-2.27,.46-1.02,1.25-1.67,1.75-1.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a`",
    d: "M90.76,135.82c0,.16,.05,.32,.13,.47-3.73,.24-9.91,.39-16.9,.39s-13.28-.16-17-.39c.01-.02,.02-.03,.03-.05,.21-.31,.15-.5-.02-.66-.03-.03-.07-.06-.1-.08-.1-.07-.21-.14-.32-.22,3.66-.25,10.09-.42,17.41-.42s13.26,.15,16.98,.39c-.15,.2-.21,.39-.21,.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a`",
    d: "M91.01,143.7c-3.72,.24-9.96,.4-17.03,.4s-13.48-.16-17.18-.41c.22-.18,.38-.38,.32-.64-.03-.15-.12-.27-.24-.37,3.71-.24,9.98-.4,17.1-.4s13.08,.15,16.82,.38c-.16,.39-.03,.72,.21,1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a`",
    d: "M91,149.46c-.06,.05-.12,.11-.17,.17-.26,.25-.45,.57-.6,.91-3.78,.21-9.65,.35-16.24,.35s-12.98-.15-16.73-.38c-.12-.27-.29-.52-.52-.74-.03-.03-.06-.06-.09-.08-.07-.06-.14-.12-.21-.19,3.64-.26,10.14-.43,17.55-.43s13.3,.16,17.02,.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a`",
    d: "M87.05,156.05c-1.11,.88-2.49,1.36-3.92,1.36h-18.84c-1.41,0-2.78-.47-3.89-1.34,3.63-.14,8.38-.23,13.59-.23s9.5,.08,13.06,.21Z"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulbIcon);
export default __webpack_public_path__ + "static/media/LightbulbIcon.7bddf0a8e1038554a77cbe86442a0677.svg";
export { ForwardRef as ReactComponent };